// ADD THE CLASS EASY READ TO THE BODY

jQuery(document).ready(function($) {
    $('#easy-read-version').click(function() {
        $(this).hide();
        $('#detailed-version').css('display', 'flex');
        $('.custom-block').toggle();
        $('body').toggleClass('easy-read');
    });
    $('#detailed-version').click(function() {
        $(this).hide();
        $('#easy-read-version').css('display', 'flex');
        $('.custom-block').toggle();
        $('body').toggleClass('easy-read');
    });

// ADD THE CLASS OPEN MENU TO THE BODY

    $('.menu-toggle').click(function() {
        $('body').toggleClass('canvas-open');
    });
    $('.close-canvas').click(function() {
        $('body').toggleClass('canvas-open');
    });

    // ADD THE CLASS OPEN AUDIO PLAYER TO THE BODY

    $('#sticky-audio-player').click(function() {
        $('body').toggleClass('audio-canvas-open');
    });
    $('#close-audio-player').click(function() {
        $('body').toggleClass('audio-canvas-open');
        $('#play').removeClass('play');
        audio.pause();
    });

    (function() {
        function getAudio() {
            const languageMap = {
                'sv-SE': '#player.swedish .audiofile',
                'sv': '#player.swedish .audiofile',
                'en': '#player.english .audiofile',
                'fi': '#player.finnish .audiofile',
                'es': '#player.spanish .audiofile',
                'no': '#player.norwegian .audiofile',
                'de': '#player.german .audiofile',
                'da': '#player.danish .audiofile',
                'fr': '#player.french .audiofile',
                'nl': '#player.dutch .audiofile',
                'ar': '#player.arabic .audiofile',
            };

            const language = $('html').attr('lang');

            if (!languageMap[language]) {
                return null;
            }

            return $(languageMap[language]).get(0);
        }

        let audio = getAudio();

        if (!audio) {
            return;
        }

        setupAudioEvents(audio);

        document.body.addEventListener('languagechanged', function() {
            audio.pause();
            audio.currentTime = 0;

            audio = getAudio();

            setupAudioEvents(audio);
        });

        // ADD 10 SECONDS SKIPPERS TO THE AUDIO FILES IN THE SINGLE STORY

        $('#backword').click(function() {
            audio.currentTime -= 10;
        });

        $('#forword').click(function() {
            audio.currentTime += 10;
        });

        // Connect and update the progress bar

        $('#play').click(function(e) {
            e.preventDefault();

            $(this).find('div').toggleClass('play');

            if (audio.paused) {
                audio.play();
            } else {
                audio.pause();
            }
        });

        $('#progress').on('input', function(e) {
            audio.pause();
            audio.currentTime = audio.duration * e.target.value / 100;
            audio.play();
            $('#play div').addClass('play');
        });

        $('.play-again-button').click(function() {
            $('body').toggleClass('audio-ended');
            audio.currentTime = 0;
            audio.play();
            $('#play div').addClass('play');
        });

        function setupAudioEvents(target) {
            target.oncanplaythrough = onCanPlayThrough;
            target.onloadeddata = onLoadedData;
            target.ontimeupdate = onTimeUpdate;
            target.onended = onEnded;
        }

        function onCanPlayThrough() {
            $('#progress').val(audio.currentTime / audio.duration * 100);
            $('#timer').text(formatTime(audio.currentTime));
        }

        function onLoadedData() {
            $('.audio-duration').each(function() {
                $(this).text(formatTime(audio.duration));
            });
        }

        function onTimeUpdate() {
            const percentage = audio.currentTime / audio.duration * 100;
            $('#progress').val(percentage);

            $('#timer').text(formatTime(audio.currentTime));
            $('#progress').get(0).style.background =
                'linear-gradient(to right, #FFCB00 0%, #FFCB00 ' +
                percentage +
                '%, #333333 ' +
                percentage +
                '%, #333333 100%)';
        }

        function onEnded() {
            $(this).find('#play div').addClass('play');
            $('body').toggleClass('audio-ended');
        }

        function formatTime(seconds) {
            let minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
            seconds = (seconds >= 10) ? seconds : '0' + seconds;
            return minutes + ':' + seconds;
        }
    }());

});








